import useAccessDeniedStep from './useAccessDeniedStep';

export default useAccessDeniedStep;
